export default __webpack_public_path__ + "static/media/logo_sm.b1348a92.svg";